export enum ShoppingCartElementEnum {
  Product = 'produit',
  Assistance = 'service',
  Accessory = 'accessoire',
}
